<div class="row">
	<mat-card-header>
		<mat-card-title>
			Search Accounts
		</mat-card-title>
	</mat-card-header>

	<mat-card-content>
		<mat-card appearance="outlined">
			<mat-card-header>
				<mat-card-title>Search Criteria</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div class="row">
					<div class="col">
						<div class="row">
							<div class="col-md-9">
								<mat-form-field style="width: 100%">
									<mat-label [ngClass]="{'danger': msg.MSG?.length!>=1}">Search by</mat-label>
									<input [formControl]="searchTextCtrl" matInput (keydown.enter)="applyFilter($event)"
										placeholder="Username or Name or Email or Phone Number or Organization">
									<mat-icon matSuffix (click)="search()">search
									</mat-icon>
								</mat-form-field>
							</div>
						</div>
						<div class="row">
							<div class="col-md-3">
								<region-dropdown-two-way [isMultiple]="true" [(selectedRegions)]="lstSelectedRegion"
									[reset]="resetField" [selectUserRegion]="true"
									(selectedRegionsChange)="disableButton = !this.validateSearchEnable()"
									[selectUserRegion]="false">
								</region-dropdown-two-way>
							</div>
							<div class="col-md-3">
								<district-dropdown-two-way [(selectedSchoolDistricts)]="lstSelecteddistrict"
									[reset]="resetField" [isMultiple]="true" [regions]="lstSelectedRegion"
									(selectedSchoolDistrictsChange)="disableButton = !this.validateSearchEnable()">
								</district-dropdown-two-way>
							</div>
							<div class="col-md-3">
								<roles-dropdown (eventEmitterRole)="roleEventEmitter($event)" [reset]="resetField">
								</roles-dropdown>
							</div>
						</div>
					</div>
					<!--div class="col"></div-->
				</div>
			</mat-card-content>
			<mat-card-actions>
				<div class="row">
					<div class="col">
						<button mat-raised-button color="primary" mat-button [disabled]="this.disableButton"
							(click)="search()">
							<mat-icon *ngIf="isLoadingResults">
								<mat-spinner diameter="20"> </mat-spinner>
							</mat-icon>
							Search
						</button>&nbsp;
						<button mat-raised-button color="accent" (click)="reset()" mat-button>Reset</button>
					</div>
				</div>
			</mat-card-actions>
		</mat-card>
	</mat-card-content>
</div>

<div class="row" style="margin-top: 15px;" class="margin-top-sm table-responsive">
	<div class="col">
		<mat-table *ngIf="this.dataSource.data.length>0" [dataSource]="dataSource" matSort
			(matSortChange)="announceSortChange($event)">
			<ng-container matColumnDef="ACTION">
				<mat-header-cell *matHeaderCellDef>
					<h3> Action </h3>
				</mat-header-cell>
				<mat-cell *matCellDef="let element">
					<button mat-icon-button color="primary" (click)="view(element)">
						<mat-icon>visibility</mat-icon>
					</button>
					<button mat-icon-button color="primary" (click)="edit(element)">
						<mat-icon>edit</mat-icon>
					</button>
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="FIRSTNAME">
				<mat-header-cell *matHeaderCellDef mat-sort-header>
					<h3> First Name </h3>
				</mat-header-cell>
				<mat-cell *matCellDef="let element">
					{{element.PERSON.FIRST_NAME}}
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="LASTNAME">
				<mat-header-cell *matHeaderCellDef mat-sort-header>
					<h3> Last Name </h3>
				</mat-header-cell>
				<mat-cell *matCellDef="let element">
					{{element.PERSON.LAST_NAME}}
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="USERNAME">
				<mat-header-cell *matHeaderCellDef mat-sort-header>
					<h3> Username </h3>
				</mat-header-cell>
				<mat-cell *matCellDef="let element">
					{{element.USER_ID}}
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="EMAIL">
				<mat-header-cell *matHeaderCellDef mat-sort-header>
					<h3> Email </h3>
				</mat-header-cell>
				<mat-cell *matCellDef="let element">
					{{element.EMAIL_ADDRESS}}
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="REGION">
				<mat-header-cell *matHeaderCellDef mat-sort-header>
					<h3> Region </h3>
				</mat-header-cell>
				<mat-cell *matCellDef="let element">
					{{element?.REGION.CODE}}
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="ORGANIZATION">
				<mat-header-cell *matHeaderCellDef mat-sort-header>
					<h3> Organization </h3>
				</mat-header-cell>
				<mat-cell *matCellDef="let element">
					{{element?.WORKS_FOR?.NAME==null ? "" : element?.WORKS_FOR?.NAME}}
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="PHONENUMBER">
				<mat-header-cell *matHeaderCellDef mat-sort-header>
					<h3> Phone Number(s) </h3>
				</mat-header-cell>
				<mat-cell *matCellDef="let element">
					{{getElementData(element)}}
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="ROLES">
				<mat-header-cell *matHeaderCellDef mat-sort-header>
					<h3> Role(s) </h3>
				</mat-header-cell>
				<mat-cell *matCellDef="let element">
					<ol style="padding-left: 1.0em;">
						<div *ngFor="let r of element.USER_ROLES;let i=index;let last=last;">
							<li *ngIf="i<3" style="word-break: break-word;">
								{{r.ROLE.NAME}}
							</li>
							<div *ngIf="i>=3 && last">
								<div class="row">
									<div class="col">
										<button mat-raised-button [matBadge]="i+1" matBadgePosition="below before"
											(click)="openDialogRoles(element.USER_ROLES)">
											<mat-icon>list</mat-icon>
										</button>
									</div>
								</div>
							</div>
						</div>
					</ol>
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="SCHOOLDISTRICT">
				<mat-header-cell *matHeaderCellDef mat-sort-header>
					<h3> School Districts(s) </h3>
				</mat-header-cell>
				<mat-cell *matCellDef="let element">
					<ol style="padding-left: 1.0em;">
						<div *ngFor="let d of element.SCHOOL_DISTRICTS;let i=index;let last=last;">
							<li *ngIf="i<3" style="word-break: break-word;">
								{{d.DISTRICTS}}
							</li>
							<div *ngIf="i>=3 && last">
								<div class="row">
									<div class="col">
										<button mat-raised-button [matBadge]="i+1" matBadgePosition="below before"
											(click)="openDialogSchoolDistrict(element.SCHOOL_DISTRICTS)">
											<mat-icon>list</mat-icon>
										</button>
									</div>
								</div>
							</div>
						</div>
					</ol>
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="ACCOUNTSTATUS">
				<mat-header-cell *matHeaderCellDef mat-sort-header>
					<h3> Account Status </h3>
				</mat-header-cell>
				<mat-cell *matCellDef="let element">
					{{element?.LOGIN_DETAIL_STATUS ==null ? "" :
					element?.LOGIN_DETAIL_STATUS[0]?.LOGIN_DETAIL_STATUS_TYPES?.NAME}}
				</mat-cell>
			</ng-container>
			<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
			<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
		</mat-table>
	</div>
</div>
<div class="row">
	<div class="col">
		<mat-paginator #searchPaginator [length]="dataSource.data.length" [pageSizeOptions]="[5, 10, 20]"
			showFirstLastButtons aria-label="Select page of periodic elements"
			[hidden]="this.dataSource?.data?.length === 0">
		</mat-paginator>
	</div>
</div>